export const thanksPath = "/thanks";

const displayName = "Спасибо!";

export default {
  path: thanksPath,
  name: "thanks",
  meta: {
    layout: "auth",
    title: displayName,
  },
  component: () => import("@/views/Thanks"),
};
